import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-asistencias-prefectos">
            <div className= "titulo-asistencias-prefectos">
                <h2>
                    Consulta de Asistencia
                </h2>
                <p>
                    Consulta las entradas y salidas de un alumnos
                </p>
            </div>
        </div>
    );
};

export default Header;